import React from "react";
import "./websiteBuilderTemplate.scss";
import classNames from "classnames";
import { IWebsiteBuilderTemplate } from "redux/reducers/models/websiteBuilder";

interface IWebsiteBuilderTemplateProps {
  template: IWebsiteBuilderTemplate;
  onClick?: () => void;
}

export default function WebsiteBuilderTemplate(props: IWebsiteBuilderTemplateProps) {
  const { template, onClick } = props;

  return (
    <div
      className={classNames("website-builder-template", {
        "website-builder-template-hover": onClick,
      })}
      onClick={onClick}
    >
      <img src={template?.image_url} alt=" " />
      <p>{template?.title}</p>
    </div>
  );
}
